import { CatalogPlan, planParameters } from '@/client/types/promotion-pricing/catalog';

interface PlanParametersProps {
  plan: CatalogPlan;
}

const humanize = (key: string): string =>
  key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

const renderValue = (value: unknown): string => {
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (value === -1) return 'Unlimited'; // backend uses -1 for "no cap"
  if (Array.isArray(value)) return `${value.length} item${value.length === 1 ? '' : 's'}`;
  if (value && typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

/** Renders the `parameters` JSON as a compact key/value grid. */
export const PlanParameters = ({ plan }: PlanParametersProps) => {
  const params = planParameters(plan);
  const entries = Object.entries(params);
  if (!entries.length) return null;

  return (
    <dl className="grid grid-cols-2 gap-x-4 gap-y-2 sm:grid-cols-3">
      {entries.map(([key, value]) => (
        <div key={key} className="min-w-0">
          <dt className="truncate text-[11px] font-medium uppercase tracking-wide text-gray-400">
            {humanize(key)}
          </dt>
          <dd className="truncate text-sm font-semibold text-gray-700">{renderValue(value)}</dd>
        </div>
      ))}
    </dl>
  );
};
